module.exports = __webpack_public_path__ + "img/u660b.26b01144.jpg";